import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const defaultDestByRole = (rol) => {
  switch (rol) {
    case 'admin':        return '/admin-turnos';
    case 'porteria':     return '/porteria-turnos';
    case 'transportista':
    case 'proveedor':    return '/dashboard';
    default:             return '/';
  }
};

const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();

  if (!token) return <Navigate to="/" replace state={{ from: location }} />;

  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return <Navigate to="/" replace />;
  }

  const now = Date.now() / 1000;
  const exp = decoded?.exp ?? 0;
  const rol = decoded?.rol;

  if (!rol || exp < now) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return <Navigate to="/" replace />;
  }

  if (decoded.requiere_cambio_clave && location.pathname !== '/cambiar-clave') {
    return <Navigate to="/cambiar-clave" replace />;
  }

  const roles = typeof allowedRoles === 'string' ? [allowedRoles] : allowedRoles;

  if (Array.isArray(roles) && roles.length > 0 && !roles.includes(rol)) {
    return <Navigate to={defaultDestByRole(rol)} replace />;
  }

  return children;
};

export default PrivateRoute;

